/* eslint-disable import/prefer-default-export */
import * as Yup from 'yup'
import i18n from '../../../i18n'
import { VALIDATION } from '../../../utils/translation-constants'
import config from 'custom/config/environment'

export const LinkAccountSchema = Yup.object().shape({
  accountNo: Yup.string()
    .matches(new RegExp(config.ACC_NO_VALIDATION), i18n.t(VALIDATION.REGACCOUNTNOVALID))
    .required(i18n.t(VALIDATION.ACCOUNTNO)),
})
